module.exports = __webpack_public_path__ + "img/title2.bd7e30ea.png";